import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeModalState } from "../../../redux/actions/Modals";
import { getModal } from "../../../redux/selectors";

import { ModalFrame } from "../Frame/Frame";
import SaveModal from "../SaveModal/SaveModal";

export const WrapModals = () => {
  const dispatch = useDispatch();

  const saveModal = useSelector(getModal('SaveModal'))

  const onCloseModal = (idModal) => {
    dispatch(changeModalState({modalName: idModal}));
  };



  return (
    <>
      {saveModal.open && (
        <ModalFrame
          closeFunc={() => onCloseModal("SaveModal")}
          id="SaveModal"
          key={`SaveModal`}
        >
          <SaveModal link={saveModal.data.link} pdfName={saveModal.data.pdfName} closeFunc={() => onCloseModal("SaveModal")} />
        </ModalFrame>
      )}
    </>
  );
};
